import { Avatar } from 'src/components/Avatar';
import { Box } from 'src/components/Box';
import { Typography } from 'src/components/Typography';
import { styled } from 'src/components/muiTheme/utils';
import { LeaderboardResultItem } from 'src/models/leaderboard/_types';

interface LeaderboardResultRowProps {
  result: LeaderboardResultItem;
  showRank?: boolean;
  showScore?: boolean;
  numeric?: boolean;
  tvMode?: boolean;
  onClick?: (result: LeaderboardResultItem) => void;
}

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(1, 0),
  borderTop: `1px solid ${theme.vars.palette.divider}`,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.vars.palette.action.hover,
  },
}));

export const LeaderboardResultRow = ({
  result,
  showRank = true,
  showScore = true,
  numeric = true,
  tvMode = false,
  onClick,
}: LeaderboardResultRowProps) => {
  const formatValue = (value: number | string) => {
    if (!numeric || typeof value === 'string') return value;
    return Number(value).toLocaleString(undefined, {
      maximumFractionDigits: 2,
    });
  };

  return (
    <Row onClick={() => onClick?.(result)}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {showRank && (
          <Box
            sx={{
              width: tvMode ? 48 : 34,
              mx: 2,
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            <Typography fontWeight="bold">{result.rank}</Typography>
          </Box>
        )}
        <Avatar
          src={result.thumbnail}
          sx={{ width: 36, height: 36, my: 1, mr: 2 }}
        />
        <Box>
          <Typography variant="body2" sx={{ m: 0 }}>
            {result.user}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ m: 0 }}>
            {result.location}
          </Typography>
        </Box>
      </Box>
      {showScore && (
        <Typography sx={{ mx: 2 }}>{formatValue(result.value)}</Typography>
      )}
    </Row>
  );
};
